import React, { useEffect,useState } from "react";
import { Pagination, Table,Button } from "rsuite";

import "rsuite/dist/rsuite-no-reset.min.css";
import { Donation } from "../../../common.interface";

const { Column, HeaderCell, Cell } = Table;
export interface ArticleTableProps{
    data:Donation[],
    myFunction:any,
    loading:boolean,
    actionText:string,
}

export default function CustomDonationTable({ data,myFunction,loading,actionText}:ArticleTableProps) {
  const [limit, setLimit] = useState(10);
  const [page, setPage] = useState(1);

  const handleChangeLimit = (dataKey: number) => {
    setPage(1);
    setLimit(dataKey);
  };

  const newData = data.filter((_:any,i:any) => {
    const start = limit * (page - 1);
    const end = start + limit;
    return i >= start && i < end;
  });

  const ButtonCell = ({ rowData, dataKey, ...props }:{rowData:any,dataKey:string}) =>(
    <Cell {...props}>
      <Button onClick={()=>myFunction(rowData[dataKey],rowData['email'],rowData['donor'])} appearance={rowData['isAcknowledged']?"ghost":"primary"} color={rowData['isAcknowledged']?"red":'orange'}>{actionText}</Button>

    </Cell>
  );

  return (
    <div className="mt-2">
      <Table autoHeight data={newData} virtualized loading={loading} >
        <Column minWidth={150} flexGrow={2} align="left" fullText={true} fixed>
          <HeaderCell>Name</HeaderCell>
          <Cell dataKey="donor" />
        </Column>

        <Column width={60} align="left" fullText={true}>
          <HeaderCell>Medium</HeaderCell>
          <Cell dataKey="payment" />
        </Column>

        <Column minWidth={80} flexGrow={1} align="left" fullText={true}>
          <HeaderCell>Amount ( GHS )</HeaderCell>
          <Cell dataKey="amount" />
        </Column>
        <Column minWidth={100} flexGrow={2} align="left" fullText={true}>
          <HeaderCell>Date</HeaderCell>
          <Cell dataKey="createdAt" />
        </Column>

        <Column width={90} align="left" fixed="right">
          <HeaderCell>Action</HeaderCell>
          <ButtonCell dataKey='_id' rowData={newData} />
        </Column>

      </Table>
      <div style={{ padding: 20, width: "100%" }}>
        <Pagination
          prev
          next
          first
          last
          ellipsis
          boundaryLinks
          maxButtons={5}
          size="xs"
          layout={["total", "-", "limit", "|", "pager", "skip"]}
          total={data.length}
          limitOptions={[20, 30, 50]}
          limit={limit}
          activePage={page}
          onChangePage={setPage}
          onChangeLimit={handleChangeLimit}
        />
      </div>
    </div>
  );
}
